/*
  EXPERIMENT · Academy app concept (branch exp/academy-app)
  File: assets/gi-academy-app.js

  Loaded only by sections/gi-ac-app-lesson.liquid. The lesson behaviour
  itself (notes, quiz, progress, restart) stays in assets/gi-academy.js.
  This adds one thing: the floating section bar marks the section being
  read (aria-current) and keeps that chip in view. Pure enhancement.
*/
(function () {
  'use strict';
  function init() {
    var toc = document.querySelector('[data-app-toc]');
    if (!toc || !('IntersectionObserver' in window)) return;
    var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#ac-step-"]'));
    var byId = {};
    links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var current = null;
    function mark(id) {
      var a = byId[id];
      if (!a || a === current) return;
      if (current) current.removeAttribute('aria-current');
      a.setAttribute('aria-current', 'true');
      current = a;
      var left = a.offsetLeft - (toc.clientWidth - a.offsetWidth) / 2;
      toc.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) mark(en.target.id); });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(byId).forEach(function (id) {
      var sec = document.getElementById(id);
      if (sec) io.observe(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
